<!--
 * @Author: Junjie
 * @Date: 2022-06-18 16:00:41
 * @LastEditTime: 2023-08-31 14:37:25
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/general/plant/index.vue
-->
<template>
  <page-layout :logo="plantInfo.plLogo" :title="plantInfo.plName">
    <detail-list :col="4" class="detail-layout" size="small" slot="headerContent">
      <detail-list-item term="负责人">{{ plantInfo.plLeader_dictText }}</detail-list-item>
      <detail-list-item term="设计日处理量(m³/天)">{{ plantInfo.plCapacity }}</detail-list-item>
      <detail-list-item term="投运日期">{{ plantInfo.plDate }}</detail-list-item>
      <detail-list-item term="运行状态">
        <span v-if="plantInfo.plStatus == 0">
          <a-tag color="#faad14">停运</a-tag>
        </span>
        <span v-else>
          <a-tag color="#52c41a">运行中</a-tag>
        </span>
      </detail-list-item>
      <a-row>
        <a-col :span="24">
          <a-button type="link">
            <router-link to="/alert/center">告警中心</router-link>
          </a-button>
          <a-button type="link">
            <router-link to="/general/process">工艺看板</router-link>
          </a-button>
          <a-button type="link">
            <router-link to="/general/dev">设备看板</router-link>
          </a-button>
          <a-button type="link">
            <router-link to="/video/ys-live">视频监控</router-link>
          </a-button>
          <a-button type="link">
            <router-link to="/doc/project">项目基本信息</router-link>
          </a-button>
          <router-link class="robotAvatarLayout" to="/intelligent/duty">
            <a-avatar :size="50" :src="require('./obotAvatar.png')" alt="智慧值守" />
          </router-link>
        </a-col>
      </a-row>
    </detail-list>

    <a-row :gutter="[8, 8]" style="margin-top: -20px">
      <a-col :span="6" class="gutter-row">
        <a-card>
          <a-row>
            <a-col :span="24">
              <chart-card :total="waterin.today" title="今日进水量" unit="m³">
                <div>
                  <trend :flag="waterin.weekflag" style="margin-right: 16px;">
                    <span slot="term">比上周</span>
                    {{ waterin.weeknum }}
                  </trend>
                  <trend :flag="waterin.yesflag">
                    <span slot="term">比昨日</span>
                    {{ waterin.yesnum }}
                  </trend>
                </div>
              </chart-card>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="6" class="gutter-row">
        <a-card>
          <a-row>
            <a-col :span="24">
              <chart-card :total="waterout.today" title="今日出水量" unit="m³">
                <div>
                  <trend :flag="waterout.weekflag" style="margin-right: 16px;">
                    <span slot="term">比上周</span>
                    {{ waterout.weeknum }}
                  </trend>
                  <trend :flag="waterout.yesflag">
                    <span slot="term">比昨日</span>
                    {{ waterout.yesnum }}
                  </trend>
                </div>
              </chart-card>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="6" class="gutter-row">
        <a-card>
          <a-row>
            <a-col :span="24">
              <chart-card :total="`${devUptimeRate}%`" title="设备完好率">
                <a-icon @click="showStatReport({}, 'devHealthStat')" slot="action" type="info-circle" />
                <div flag="down">
                  <a-progress
                    :percent="devUptimeRate"
                    :stroke-color="{
                      '0%': '#FF780A',
                      '100%': '#73BF69'
                    }"
                    :width="90"
                  />
                </div>
              </chart-card>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="6" class="gutter-row">
        <a-card>
          <a-row>
            <a-col :span="24">
              <chart-card :total="`${maintaince.total}`" :unit="`完结率${maintaince.percent}%`" title="本月保养任务">
                <a-icon @click="showStatReport({}, 'matintainceStat')" slot="action" type="info-circle" />
                <div flag="down">
                  <a-progress
                    :percent="maintaince.percent"
                    :stroke-color="{
                      '0%': '#FF780A',
                      '100%': '#73BF69'
                    }"
                    :width="90"
                  />
                </div>
              </chart-card>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>

    <a-row>
      <a-tabs default-active-key="table" style="background-color: #fff;" type="card">
        <a-tab-pane key="table">
          <span slot="tab"> <a-icon type="table" />数据 </span>
          <a-row :gutter="[8, 8]">
            <a-col :span="4" class="gutter-row">
              <a-card :bordered="false" title="进出水量">
                <a-table
                  :columns="tableOpts.waterFlow.columns"
                  :dataSource="tableOpts.waterFlow.dataSource"
                  :pagination="false"
                  :scroll="{ y: 220 }"
                  bordered
                  class="j-table-force-nowrap"
                  ref="flow-table"
                  rowKey="dataTime"
                  size="small"
                ></a-table>
              </a-card>
            </a-col>
            <a-col :span="4" class="gutter-row">
              <a-card :bordered="false" title="瞬时流量">
                <a-table
                  :columns="tableOpts.flowRate.columns"
                  :dataSource="tableOpts.flowRate.dataSource"
                  :pagination="false"
                  :scroll="{ y: 220 }"
                  bordered
                  class="j-table-force-nowrap"
                  ref="flow-table"
                  rowKey="index"
                  size="small"
                ></a-table>
              </a-card>
            </a-col>
            <a-col :span="8" class="gutter-row">
              <a-card :bordered="false" title="进水水质">
                <a-table
                  :columns="tableOpts.waterinQuality.columns"
                  :dataSource="tableOpts.waterinQuality.dataSource"
                  :pagination="false"
                  :scroll="{ y: 220 }"
                  bordered
                  class="j-table-force-nowrap"
                  ref="flow-table"
                  rowKey="index"
                  size="small"
                ></a-table>
              </a-card>
            </a-col>
            <a-col :span="8" class="gutter-row">
              <a-card :bordered="false" title="出水水质">
                <a-table
                  :columns="tableOpts.wateroutQuality.columns"
                  :dataSource="tableOpts.wateroutQuality.dataSource"
                  :pagination="false"
                  :scroll="{ y: 220 }"
                  bordered
                  class="j-table-force-nowrap"
                  ref="flow-table"
                  rowKey="index"
                  size="small"
                ></a-table>
              </a-card>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="chart">
          <span slot="tab"> <a-icon type="line-chart" />曲线 </span>
          <a-row :gutter="[8, 8]">
            <a-col :span="6" class="gutter-row">
              <a-card :bordered="false" title="进出水量">
                <template #extra></template>
                <v-chart
                  :option="influentAndEffluentWaterQuantity"
                  style="width: 100%; height: 200px; background-color: #fff"
                />
              </a-card>
            </a-col>
            <a-col :span="6" class="gutter-row">
              <a-card :bordered="false" title="瞬时流量">
                <template #extra></template>
                <v-chart
                  :option="influentAndEffluentWaterFlowRate"
                  style="width: 100%; height: 200px; background-color: #fff"
                />
              </a-card>
            </a-col>
            <a-col :span="6" class="gutter-row">
              <a-card :bordered="false" title="进水水质">
                <template #extra></template>
                <v-chart :option="waterinQualityOpts" style="width: 100%; height: 200px; background-color: #fff" />
              </a-card>
            </a-col>
            <a-col :span="6" class="gutter-row">
              <a-card :bordered="false" title="出水水质">
                <template #extra></template>
                <v-chart :option="wateroutQualityOpts" style="width: 100%; height: 200px; background-color: #fff" />
              </a-card>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <a-row :gutter="[8, 8]">
      <a-col :span="6" class="gutter-row">
        <a-card :bordered="false" title="本月告警统计">
          <template #extra>
            <a @click="handleToUrl('/alert/history')" href="javascript:;">历史告警</a>
          </template>
          <chart-card :total="alertTotal" title="已处理/未处理">
            <a-progress :percent="alertPercent" :successPercent="alertPercent" />
          </chart-card>
          <v-chart :option="alarmStatistics" ref="myChart" style="width: 100%; height: 235px; background-color: #fff" />
        </a-card>
      </a-col>
      <a-col :span="18" class="gutter-row">
        <a-card :bordered="false" title="未处理告警">
          <template #extra>
            <a @click="handleToUrl('/alert/center')" href="javascript:;">告警中心</a>
          </template>

          <grid-table :columns="columns" :queryParams="{ disposal: 0 }" ref="table" url="/alert/iotAlert/list">
            <template slot="htmlSlot" slot-scope="text">
              <div v-html="text"></div>
            </template>

            <template slot="fileSlot" slot-scope="text">
              <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
              <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
                >下载</a-button
              >
            </template>
            <span slot="levelSlot" slot-scope="alertLevel, item">
              <span v-if="item.alertLevel == 1">
                <a-tag color="#ff4d4f">紧急告警</a-tag>
              </span>
              <span v-else-if="item.alertLevel == 2">
                <a-tag color="#faad14">严重告警</a-tag>
              </span>
              <span v-else>
                <a-tag color="#52c41a">一般告警</a-tag>
              </span>
            </span>
            <span slot="recoverySlot" slot-scope="text, item">
              <a-tag color="#ff4d4f" v-if="item.isRecovery == 0">未恢复</a-tag>
              <a-tag color="#52c41a" v-else>已恢复</a-tag>
            </span>
          </grid-table>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="[8, 8]" style="margin-top: -20px">
      <a-card :bordered="false" title="设备故障">
        <template #extra>
          <a @click="handleToUrl('/defect/defRegister')" href="javascript:;">缺陷管理</a>
        </template>
        <grid-table
          :columns="defectColumns"
          :queryParams="{ defStatusStr: '0,1,2' }"
          ref="defectTable"
          url="/device/defRegister/list"
        >
          <span slot="defType" slot-scope="defType, record">
            <span v-if="record.defType == 1">
              <a-tag>设备类型</a-tag>
            </span>
            <span v-else-if="record.defType == 2">
              <a-tag>非设备类型</a-tag>
            </span>
          </span>
          <span slot="defLevel" slot-scope="priority, record">
            <a-tag :color="$filterDictTextByCache('def_level_color', record.defLevel)">{{
              record.defLevel_dictText
            }}</a-tag>
          </span>
        </grid-table>
      </a-card>
    </a-row>
    <iframe-drawer ref="iframeDrawer"></iframe-drawer>
  </page-layout>
</template>

<script>
import '@/assets/less/TableExpand.less'
import PageLayout from '@/components/page/PageLayout'
import { httpAction, getAction } from '@/api/manage'
import ChartCard from '@/components/ChartCard'
import ACol from 'ant-design-vue/es/grid/Col'
import ATooltip from 'ant-design-vue/es/tooltip/Tooltip'
import MiniArea from '@/components/chart/MiniArea'
import MiniBar from '@/components/chart/MiniBar'
import MiniProgress from '@/components/chart/MiniProgress'
import RankList from '@/components/chart/RankList'
import Bar from '@/components/chart/Bar'
import LineChartMultid from '@/components/chart/LineChartMultid'
import HeadInfo from '@/components/tools/HeadInfo.vue'
import Trend from '@/components/Trend'
import DetailList from '@/components/tools/DetailList'
import { use } from 'echarts/core'
import { LegendComponent, VisualMapComponent, TitleComponent, CalendarComponent } from 'echarts/components'
import { LineChart, HeatmapChart, PieChart } from 'echarts/charts'
import GridTable from '@/views/workbench/components/Itable.vue'

use([LineChart, HeatmapChart, LegendComponent, VisualMapComponent, TitleComponent, CalendarComponent, PieChart])

import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import moment from 'dayjs'
import { validatenull, validatenotnull } from '@/utils/validate'

const DetailListItem = DetailList.Item
export default {
  name: 'Overview',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    GridTable,
    PageLayout,
    DetailList,
    DetailListItem,
    ATooltip,
    ACol,
    ChartCard,
    MiniArea,
    MiniBar,
    MiniProgress,
    RankList,
    Bar,
    Trend,
    LineChartMultid,
    HeadInfo
  },
  data() {
    const forceNowrap = text => <span class="j-force-nowrap">{text}</span>
    return {
      disableMixinCreated: true,
      plantInfo: {},
      url: {
        list: '/device/sewegePlantList/list',
        maintainceStat: '/maintenance/devMaintainceTask/stat',
        iotAlertListUrl: '/alert/iotAlert/list',
        iotAlertPlantStatisticsUrl: '/alert/iotAlert/getIotAlertPlantStatistics',
        waterQuality: '/plant/dashboard/quality',
        waterFlow: '/plant/dashboard/flow',
        waterFlowRate: '/plant/dashboard/flowrate',
        devUptimeRateUrl: '/device/devList/getDevUptimeRate',
        getReportUrl: '/custom/commonOnlReport/list'
      },
      waterout: {
        today: '0',
        yesflag: 'up',
        yesnum: '0%',
        weekflag: 'up',
        weeknum: '0%'
      },
      waterin: {
        today: '0',
        yesflag: 'up',
        yesnum: '0%',
        weekflag: 'up',
        weeknum: '0%'
      },
      maintaince: {
        total: 0,
        percent: 100
      },
      influentAndEffluentWaterQuantity: {},
      influentAndEffluentWaterFlowRate: {},
      waterinQualityOpts: {},
      wateroutQualityOpts: {},
      alarmStatistics: {},
      tableOpts: {
        waterFlow: {
          columns: [
            {
              title: '时间',
              align: 'center',
              dataIndex: 'dataTime',
              width: 60
            },
            {
              title: '进水',
              align: 'right',
              dataIndex: 'waterinFlow'
            },
            {
              title: '出水',
              align: 'right',
              dataIndex: 'wateroutFlow'
            }
          ],
          dataSource: []
        },
        flowRate: {},
        waterinQuality: {},
        wateroutQuality: {}
      },
      // 表头
      columns: [
        {
          title: '告警描述',
          align: 'center',
          dataIndex: 'summary',
          width: '50%',
          align: 'left'
        },
        {
          title: '告警时间',
          align: 'center',
          dataIndex: 'alertTime',
          customRender: forceNowrap
        },
        {
          title: '告警级别',
          align: 'center',
          dataIndex: 'alertLevel_dictText',
          scopedSlots: { customRender: 'levelSlot' }
        },
        {
          title: '告警来源',
          align: 'center',
          dataIndex: 'alertType_dictText',
          customRender: forceNowrap
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'isRecovery',
          scopedSlots: { customRender: 'recoverySlot' }
        }
      ],
      defectColumns: [
        {
          title: '设备名称',
          align: 'center',
          dataIndex: 'devName',
          sorter: true
        },
        {
          title: '缺陷内容',
          align: 'center',
          dataIndex: 'defContent'
        },
        {
          title: '缺陷部位',
          align: 'center',
          dataIndex: 'defPart'
        },
        {
          title: '缺陷类别',
          align: 'center',
          dataIndex: 'defCategory',
          sorter: true
        },
        {
          title: '缺陷等级',
          align: 'center',
          dataIndex: 'defLevel',
          scopedSlots: { customRender: 'defLevel' },
          sorter: true
        },
        {
          title: '缺陷发现人',
          align: 'center',
          dataIndex: 'defInventor_dictText',
          scopedSlots: { customRender: 'defInventor' }
        },
        {
          title: '缺陷发现时间',
          align: 'center',
          dataIndex: 'defFindTime',
          width: 180,
          sorter: true
        },
        {
          title: '当前状态',
          align: 'center',
          dataIndex: 'defStatus_dictText',
          sorter: true
        }
      ],
      alertTotal: '0/0',
      alertPercent: 0,
      devUptimeRate: 100,
      reportUrl: {}
    }
  },
  created() {
    this.loadSewegeInfo()
    this.getMaintainceStat()
    this.getWaterFlow()
    this.getWaterFlowRate()
    this.getWaterQuality()
    this.getIotAlertPlantStatistics()
    this.getDevUptimeRate()

    const that = this
    getAction(this.url.getReportUrl, { reportGroup: 'drill-ana' }).then(res => {
      if (res.success && res.result) {
        res.result.records.forEach(rep => {
          that.reportUrl[rep.shortName] = rep.url
        })
      }
    })
  },
  methods: {
    loadSewegeInfo() {
      getAction(this.url.list, {}).then(res => {
        if (res.success) {
          const originMedel = res.result.records[0]
          if (originMedel) {
            this.plantInfo = originMedel
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getMaintainceStat() {
      getAction(this.url.maintainceStat, {}).then(res => {
        if (res.success) {
          const stat = res.result
          this.maintaince.total = stat.total + ''
          if (stat.total - 0 > 0) {
            this.maintaince.percent = parseFloat(((stat.finished * 100) / stat.total).toFixed(1))
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getDevUptimeRate() {
      getAction(this.url.devUptimeRateUrl, {}).then(res => {
        if (res.success) {
          this.devUptimeRate = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    isUsualNum(s) {
      return !isNaN(s) && isFinite(s)
    },
    getWaterFlow() {
      getAction(this.url.waterFlow, {}).then(res => {
        if (res.success) {
          const waterinFlow = res.result.waterinFlow
          const waterinToday = waterinFlow[waterinFlow.length - 1]?.value || 0
          const waterinYesterday = waterinFlow[waterinFlow.length - 2].value || 0
          const waterinLastWeek = waterinFlow[waterinFlow.length - 8].value || 0
          const waterinYesFlag = waterinToday - waterinYesterday < 0 ? 'down' : 'up'
          const waterinYesNum = this.isUsualNum(((waterinToday - waterinYesterday) * 100) / waterinYesterday)
            ? (((waterinToday - waterinYesterday) * 100) / waterinYesterday).toFixed(2) + '%'
            : '--'
          const waterinWeekFlag = waterinToday - waterinLastWeek < 0 ? 'down' : 'up'
          const waterinWeekNum = this.isUsualNum(((waterinToday - waterinLastWeek) * 100) / waterinLastWeek)
            ? (((waterinToday - waterinLastWeek) * 100) / waterinLastWeek).toFixed(2) + '%'
            : '--'
          this.waterin = Object.assign(this.waterin, {
            today: waterinToday.toFixed(2) + '',
            yesflag: waterinYesFlag,
            yesnum: waterinYesNum,
            weekflag: waterinWeekFlag,
            weeknum: waterinWeekNum
          })

          const wateroutFlow = res.result.wateroutFlow
          const waternoutToday = wateroutFlow[wateroutFlow.length - 1].value || 0
          const waternoutYesterday = wateroutFlow[wateroutFlow.length - 2].value || 0
          const waternoutLastWeek = wateroutFlow[wateroutFlow.length - 8].value || 0
          const waternoutYesFlag = waternoutToday - waternoutYesterday < 0 ? 'down' : 'up'
          const waternoutYesNum = this.isUsualNum(((waternoutToday - waternoutYesterday) * 100) / waternoutYesterday)
            ? (((waternoutToday - waternoutYesterday) * 100) / waternoutYesterday).toFixed(2) + '%'
            : '--'
          const wateroutWeekFlag = waternoutToday - waternoutLastWeek < 0 ? 'down' : 'up'
          const wateroutWeekNum = this.isUsualNum(((waternoutToday - waternoutLastWeek) * 100) / waternoutLastWeek)
            ? (((waternoutToday - waternoutLastWeek) * 100) / waternoutLastWeek).toFixed(2) + '%'
            : '--'
          this.waterout = Object.assign(this.waterout, {
            today: waternoutToday.toFixed(2) + '',
            yesflag: waternoutYesFlag,
            yesnum: waternoutYesNum,
            weekflag: wateroutWeekFlag,
            weeknum: wateroutWeekNum
          })

          const xAxis = []
          const waterin = []
          const waterout = []

          waterinFlow.forEach((flow, index) => {
            xAxis.push(flow.timeStamp.substring(0, 10))
            waterin.push(flow.value || 0)
            waterout.push(wateroutFlow[index]?.value || 0)

            this.tableOpts.waterFlow.dataSource.unshift({
              dataTime: flow.timeStamp.substring(5, 10),
              waterinFlow: flow.value || 0,
              wateroutFlow: wateroutFlow[index]?.value || 0
            })
          })

          this.influentAndEffluentWaterQuantity = {
            grid: {
              top: 30,
              bottom: 20,
              left: 45,
              right: 0
            },
            // 图例
            legend: {
              data: ['进水', '出水'],
              top: 0
            },
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'category',
              data: xAxis
              // axisLabel: {
              //   interval: 5
              // }
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                data: waterin,
                name: '进水',
                type: 'bar',
                barMaxWidth: 50,
                itemStyle: {
                  color: '#ccc400'
                },
                label: {
                  position: 'top'
                }
              },
              {
                data: waterout,
                name: '出水',
                type: 'bar',
                barMaxWidth: 50,
                itemStyle: {
                  color: 'rgba(23, 177, 177, 1)'
                },
                label: {
                  // 柱状图上方文本标签，默认展示数值信息
                  // show: true,
                  position: 'top'
                }
              }
            ]
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getWaterFlowRate() {
      getAction(this.url.waterFlowRate, {}).then(res => {
        if (res.success) {
          const waterinFlowRate = res.result.waterinList
          const wateroutFlowRate = res.result.wateroutList

          const allData = [...waterinFlowRate, ...wateroutFlowRate]
          this.influentAndEffluentWaterFlowRate = this.renderWaterQualityLIne(allData)
          this.tableOpts.flowRate = this.getTableOpts(allData)
        }
      })
    },
    getWaterQuality() {
      getAction(this.url.waterQuality, {}).then(res => {
        if (res.success) {
          const waterinQuality = res.result.waterinList
          this.waterinQualityOpts = this.renderWaterQualityLIne(waterinQuality)
          this.tableOpts.waterinQuality = this.getTableOpts(waterinQuality)

          const wateroutQuality = res.result.wateroutList
          this.wateroutQualityOpts = this.renderWaterQualityLIne(wateroutQuality)
          this.tableOpts.wateroutQuality = this.getTableOpts(wateroutQuality)
        }
      })
    },
    getTableOpts(dataList) {
      // Extract unique timestamps from dataList
      const timestamps = [...new Set(dataList.flatMap(item => item.details.map(detail => detail.time)))]

      // Generate columns array with timestamp column and parameter columns
      const columns = [
        { title: '时间', dataIndex: 'time', key: 'time', align: 'center', width: 60 },
        ...dataList.map(item => ({
          title: item.shortName || item.desc,
          dataIndex: item.pointCode,
          key: item.pointCode,
          ellipsis: true,
          align: 'right'
        }))
      ]

      // Generate dataSource array with values for each timestamp and parameter
      const dataSource = timestamps.map(timestamp => {
        const rowData = { time: timestamp.substring(11, 16) }
        dataList.forEach(item => {
          const detail = item.details.find(detail => detail.time === timestamp)
          rowData[item.pointCode] = detail ? detail.value : '-'
        })
        return rowData
      })

      return { columns, dataSource }
    },
    renderWaterQualityLIne(dataList) {
      const legends = []
      const series = []
      if (dataList && dataList.length > 0) {
        dataList.forEach(info => {
          series.push({
            name: info.shortName || info.desc,
            data: this.objectArrTo2Array(info.details),
            type: 'line',
            smooth: true,
            step: false,
            showSymbol: false
          })
          legends.push(info.shortName || info.desc)
        })
      }

      const options = {
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            let relVal = moment(params[0].value[0]).format('YYYY-MM-DD HH:mm')
            for (let i = 0, l = params.length; i < l; i++) {
              // 遍历出来的值一般是字符串，需要转换成数字，再进项tiFixed四舍五入
              relVal +=
                '<br/>' +
                params[i].marker +
                params[i].seriesName +
                ' : ' +
                (params[i].value[1] === null ? '' : Number(params[i].value[1]).toFixed(2))
            }
            return relVal
          }
        },
        // 图例
        legend: {
          data: legends,
          top: 0,
          type: 'scroll'
        },
        grid: {
          top: 30,
          left: 50,
          right: 0,
          bottom: 20
        },
        xAxis: {
          type: 'time'
        },
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: series
      }
      return options
    },
    getAlarmStatistics(data) {
      //总数+计算百分比
      ;(this.alertTotal =
        (validatenotnull(data.processedCount) ? data.processedCount : 0) +
        '/' +
        (validatenotnull(data.untreatedCount) ? data.untreatedCount : 0)),
        (this.alertPercent = Number(
          data.alertCount == 0 ? 0 : ((data.processedCount / data.alertCount) * 100).toFixed(2)
        ))
      //封装警告数据
      const result = []
      if (validatenotnull(data.alertLevelMap)) {
        for (let key in data.alertLevelMap) {
          let obj = {}
          if (key == 1) {
            obj.name = '紧急告警'
          } else if (key == 2) {
            obj.name = '严重告警'
          } else if (key == 3) {
            obj.name = '一般告警'
          }
          obj.value = data.alertLevelMap[key]
          result.push(obj)
        }
      }
      const alarmCounts = validatenotnull(data.alertCount) ? data.alertCount : 0
      this.alarmStatistics = {
        title: {
          text: '告警总数', // 主标题
          textStyle: {
            // 主标题样式
            color: '#333',
            fontSize: 14
          },
          left: '49%', // 定位到适合的位置
          top: '41%', // 定位到适合的位置
          x: 'center',
          y: 'center',
          subtext: alarmCounts, // 副标题
          subtextStyle: {
            // 副标题样式
            color: 'red',
            fontSize: 13,
            fontWeight: 'bold'
          },
          textAlign: 'center' // 主、副标题水平居中显示
        },
        color: ['#ef6567', '#f9c956', '#5470c6'],
        series: [
          {
            type: 'pie',
            radius: [40, 60],
            data: result,
            label: {
              formatter: '{name|{b}}\n{time|{c}}',
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 12,
                  color: '#999'
                }
              }
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80
            },
            labelLayout: function(params) {
              const isLeft = params.labelRect.x < 200 / 2
              const points = params.labelLinePoints
              // Update the end point.
              points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width
              return {
                labelLinePoints: points
              }
            }
          }
        ]
      }
    },

    getIotAlertPlantStatistics() {
      //传入月份第一天和最后一天
      const firstDay =
        moment()
          .startOf('month')
          .format('YYYY-MM-DD') + ' 00:00:00'
      getAction(this.url.iotAlertPlantStatisticsUrl, Object.assign({ alertTime_begin: firstDay })).then(res => {
        if (res.success) {
          if (validatenotnull(res.result)) {
            this.getAlarmStatistics(res.result)
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleToUrl(url, params) {
      if (validatenull(url)) {
        return
      }
      this.$router.push({ path: url, query: params })
    },
    objectArrTo2Array(arrs) {
      const res = []
      arrs.forEach(arr => {
        const item = [arr.timeStamp, arr.value]
        res.push(item)
      })
      return res
    },
    showStatReport(record, reportKey, key, paramKey) {
      let url = this.reportUrl[reportKey]
      if (!url) {
        this.$message.warning('未找到统计信息配置')
      }
      if (key) {
        if (url.indexOf(`${paramKey}`) > -1) {
          url = url.replace(`\$\{${paramKey}\}`, record[key])
        } else {
          url += `&${paramKey}=${record[key]}`
        }
      }
      url = url.replace('${tenant_id}', this.$ls.get('TENANT_ID'))
      this.$refs['iframeDrawer'].show(url)
    },
    to3Dpage() {
      const iframeWindow = document.getElementById('commentIframegeneral-3d--visualView-#-')
      if (iframeWindow) {
        iframeWindow.contentWindow.postMessage('gongyi', '*')
        this.$router.push({ path: '/general/3d' })
      } else {
        this.$message.info('请先打开三维页面加载模型！')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 8px;
}

.ant-col-5 {
  width: 20%;
}

.detail-layout {
  margin-left: 44px;
}

.text {
  color: rgba(0, 0, 0, 0.45);
}

.heading {
  color: rgba(0, 0, 0, 0.85);
  font-size: 20px;
}

.no-data {
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
  line-height: 64px;
  font-size: 16px;

  i {
    font-size: 24px;
    margin-right: 16px;
    position: relative;
    top: 3px;
  }
}

.mobile {
  .detail-layout {
    margin-left: unset;
  }

  .status-list {
    text-align: left;
  }
}

.speakLayout {
  cursor: pointer;
  float: right;
  margin-top: -20px;
}
.robotAvatarLayout {
  float: right;
  margin-top: -50px;
  margin-bottom: 10px;
}
</style>
